exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".desc[data-v-184d5d7d]{margin:3px 5px 15px}.detailButton[data-v-184d5d7d]{display:inline-block;line-height:1;white-space:nowrap;cursor:pointer;background:#fff;border:1px solid #d8dce5;box-sizing:border-box;outline:0;margin:3px;transition:.1s;padding:11px;border-radius:50%}.keywords[data-v-184d5d7d]{margin:15px 5px}.keywords .el-tag[data-v-184d5d7d]{margin:5px}.buttons[data-v-184d5d7d]{margin:20px 5px 0}.listBlock[data-v-184d5d7d]{padding-top:25px}.listBlock #createProjectButton[data-v-184d5d7d]{border-color:orange}.listBlock #createProjectButton[data-v-184d5d7d]:hover{background-color:#fff;color:orange}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-184d5d7d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/TheList.vue
// module id = 315
// module chunks = 0